module.exports = {"pageTitleText":"缓存清除","addBtnText":"清除快取"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/cacheclear.json
// module id = MsqF
// module chunks = 3